module.exports = __webpack_public_path__ + "static/4-49806e8bc20b004c9c4dd90641df1f60.jpeg";